<template>
  <UiTable
    :storage-id="storageId"
    :source-columns="columns"
    :rows="rows"
    :is-loading="isLoading"
    :pagination="{ 'page-index': page, 'page-size': pageSize }"
    :table-props="{ 'cell-style-option': cellStyleOption }"
    :total="total"
    v-on="paginationListeners"
  />
</template>

<script>
import { LogsService } from '@/services/logs.service'
import { redirectIfDenied } from '@/services/ability.service'

import tableDefaults from '@/components/table/tableDefaults'

import columns from './columns.js'

import UiTable from '@/components/table/UiTable.vue'
import syncQuery from '@/mixins/syncUrlQuery'

import levels from '../levels'

export default {
  components: { UiTable },
  mixins: [syncQuery, columns, tableDefaults],
  data() {
    return {
      storageId: 'logs-table',
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          const styles = {
            [levels.INFO]: 'row-info',
            [levels.ERROR]: 'row-error',
            [levels.WARNING]: 'row-warning',
          }

          const rowColor = styles[row.level]
          const rowSolved = row.solved ? 'row-solved' : ''

          // Returns string classes. Eg: 'row-info solved'
          return `${rowColor} ${rowSolved}`
        },
      },
    }
  },
  watch: {
    '$route.query': {
      handler: 'getLogsList',
      immediate: true,
    },
  },
  mounted() {
    this.syncQuery({ localField: 'pageSize', queryField: 'pageSize', query2local: (v) => +v })
    this.syncQuery({ localField: 'page', queryField: 'page', query2local: (v) => +v })
  },
  methods: {
    /**
     * Send request to backend for get list of logs
     *
     * @returns {Object} data Response wrapper. Contains `content` and `total` parameters.
     * */
    async getLogsList() {
      this.isLoading = true

      try {
        const { data } = await LogsService.getList(
          this.colletQueryParams({
            level_id: this.$query.level,
          })
        )

        this.rows = data.content
        this.total = data.total
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message

        redirectIfDenied.call(this, e)
      } finally {
        this.isLoading = false
      }
    },

    /**
     * Send request to solve log.
     *
     * @returns {Object} data Response wrapper.
     * */
    async solveLog(row) {
      try {
        const response = await LogsService.solve({ logId: row.id })

        row.solved = response.data.content.solved

        this.$store.dispatch('logs/getUnsolvedCount')
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message
      }
    },
  },
}
</script>
